import { render, staticRenderFns } from "./VerifyCodeInput.vue?vue&type=template&id=6fba1c3c&scoped=true"
import script from "./VerifyCodeInput.vue?vue&type=script&lang=js"
export * from "./VerifyCodeInput.vue?vue&type=script&lang=js"
import style0 from "./VerifyCodeInput.vue?vue&type=style&index=0&id=6fba1c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba1c3c",
  null
  
)

export default component.exports